import { create } from "zustand";

export interface AuthUser {
  id: string;
  organizationId: string;
  fullName: string;
  email: string;
  roles: string[];
  permissions: string[];
  /** Presente solo para usuarios de portal de cliente (rol CLIENTE vinculado a un Client, Fase 19). */
  clientId: string | null;
}

interface AuthState {
  user: AuthUser | null;
  accessToken: string | null;
  isAuthenticated: boolean;
  setSession: (user: AuthUser, accessToken: string) => void;
  setAccessToken: (accessToken: string) => void;
  logout: () => void;
  hasPermission: (permission: string) => boolean;
}

/**
 * El access token se guarda SOLO en memoria (no localStorage/sessionStorage)
 * para reducir superficie de ataque XSS. La persistencia de sesión entre
 * recargas se logra mediante el refresh token en cookie httpOnly + Secure,
 * que el backend valida en POST /api/auth/refresh (ver Fase 3).
 */
export const useAuthStore = create<AuthState>((set, get) => ({
  user: null,
  accessToken: null,
  isAuthenticated: false,
  setSession: (user, accessToken) => set({ user, accessToken, isAuthenticated: true }),
  setAccessToken: (accessToken) => set({ accessToken }),
  logout: () => set({ user: null, accessToken: null, isAuthenticated: false }),
  hasPermission: (permission: string) => {
    const { user } = get();
    if (!user) return false;
    return user.permissions.includes("*") || user.permissions.includes(permission);
  },
}));
